import app from 'flarum/common/app';

// Exact date + time shown instead of Flarum's relative "X ago" text.
const TIME_FORMAT = 'YYYY-MM-DD HH:mm';

app.initializers.add('alwarithun-absolute-time', () => {
  // Flarum exposes its bundled dayjs on `window.dayjs`, so we patch the exact
  // instance core's humanTime() uses (a locally-installed dayjs would be a
  // separate copy and patching it would have no effect).
  const dayjs = window.dayjs;

  if (!dayjs) {
    return;
  }

  // Core's humanTime() shows "X ago" for recent dates via dayjs.fromNow().
  // Make it return an exact date + time instead. Dates older than ~30 days go
  // through core's humanTimeShort/Long format keys, overridden in /locale.
  dayjs.prototype.fromNow = function () {
    return this.format(TIME_FORMAT);
  };
});
